resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function InvestorsNavigation() {
  this.extends = [_ResponsiveLayout, _Secured]; // _Secured for paths
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.type = "marketing"; // || portal

  this.init = function() {
    this._onScroll();
    $(document).on("scroll", $.proxy(this._onScroll, this));
  };

  this.initAllReady = function() {};

  this._onScroll = function(evt) {
    var scrollTop = $(document).scrollTop();
    if (scrollTop <= 100) {
      $(this.node).removeClass("mogo-investors__header--scrolled");
    }
    else if (scrollTop >= 100) {
      $(this.node).addClass("mogo-investors__header--scrolled");
    }
  };
}
